export const detail = {
  coinImage: '/assets/profile/usdt.png',
  coinValue: 15,
  status: 'success',
  txID: '0xfc954aDacd66199fb02961518AdDf05991d9B4CC',
  orderID: '0xfc954aDacd66199fb02961518AdDf05991d9B4CC',
  time: '8/16/2024, 4:58:39 pm',
}
